import React from "react";
import { Col, Row, Badge } from "react-bootstrap";
import { Zoom } from "react-awesome-reveal";
import SplitNumber from "../../../components/SplitNumber";
import {
  IconArrowDown,
  IconArrowUp,
  IconTooman,
} from "../../../../assets/icons";

function TransactionItem(props) {
  const itemCharge = props.ItemCharge;
  let ChargeType = "";
  let color = "";
  let icon = "";
  let ChargeLabel = "";
  let bgColor = "";

  if (itemCharge == 1) {
    ChargeType = "واریز";
    color = "success";
    icon = <IconArrowUp fillColor="#09a463" />;
    ChargeLabel = "افزایش موجودی";
    bgColor = "#09a463";
  } else {
    ChargeType = "برداشت";
    color = "danger";
    icon = <IconArrowDown fillColor="#f80248" />;
    ChargeLabel = "کاهش موجودی";
    bgColor = "#f80248";
  }

  return (
    <Col xs={12} lg={4} className="mt-3 mt-md-4">
      <Zoom triggerOnce={true} className="h-100">
        <div
          className="bg-white shadow-sm rounded-4 p-3 h-100"
          style={{ borderRight: `5px solid ${bgColor}` }}
        >
          <Row className="mb-2 pb-2">
            <Col xs="12" className="ps-1">
              <div className="d-flex justify-content-between mb-2">
                <span className="fs-085 text-muted">
                  {icon} <span className={`text-${color}`}>{ChargeType}</span>
                </span>

                <div>
                  <Badge bg={color} className="w-100 fw-normal fs-075">
                    {ChargeLabel}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-3 mb-2">
            <Col xs="auto" className="pe-0 text-muted">
              مبلغ
            </Col>
            <Col className="my-auto opacity-10">
              <div
                style={{
                  borderTop: "1px dashed #000",
                  height: "1px",
                }}
              ></div>
            </Col>
            <Col xs="auto" className="text-end text-dark medium-svg">
              <span className="fw-bold">
                <SplitNumber number={props.ItemPrice} />
              </span>
              <span>
                <IconTooman fillColor="#000" style={{ marginTop: "-7px" }} />
              </span>
            </Col>
          </Row>
          <Row className="mt-2 mb-3">
            <Col xs="auto" className="pe-0 text-muted">
              تاریخ
            </Col>
            <Col className="my-auto opacity-10">
              <div
                style={{
                  borderTop: "1px dashed #000",
                  height: "1px",
                }}
              ></div>
            </Col>
            <Col xs="auto" className="text-end text-dark medium-svg">
              {props.ItemTime} - {props.ItemDate}
            </Col>
          </Row>
          <Row className="border-top mt-1 pt-1">
            <Col xs={12}>
              <div className="text-dark pt-2 mt-1 ">
                <div className="fs-075 text-start">{props.ItemDescription}</div>
                <div className="fs-075 text-muted mt-1 text-start">
                  {props.Title} {props.ItemCode}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Zoom>
    </Col>
  );
}
export default TransactionItem;
